<ra-modal
    [title]="('document.edit.documentVisibility.title' | translate)"
    [size]="'small'"
    [pushed]="pushed()"
    [disabled]="loading()"
    (close)="close.emit()">

    <div class="visibility-body">
        <div class="options-card">
            <!-- Documento privado -->
            <div class="option-row">
                <div class="option-text">
                    <span class="option-title">{{ 'document.edit.documentVisibility.privateDocument' | translate }}</span>
                    <span class="option-description">
                        @if (canToggle()) {
                            {{ 'document.edit.documentVisibility.privateDocumentHint' | translate }}
                        } @else {
                            {{ 'document.edit.documentVisibility.contractAlwaysPrivate' | translate }}
                        }
                    </span>
                </div>
                <ra-switch [formControl]="privateControl" />
            </div>

            <!-- Quem pode acessar — aparece sempre, desabilitado quando o doc é público -->
            <button
                type="button"
                class="option-row option-row--button"
                [disabled]="!isPrivate()"
                (click)="openAccessList.emit()">
                <div class="option-text">
                    <span class="option-title">{{ 'document.edit.documentVisibility.whoCanAccess' | translate }}</span>
                    <span class="option-description">{{ 'document.edit.documentVisibility.whoCanAccessHint' | translate }}</span>
                </div>
                <ra-icon icon="arrow-right" varColor="contentSecondary" [size]="18" />
            </button>
        </div>
    </div>
</ra-modal>
